import { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { useAuth } from '../lib/AuthContext'

const SS_KEY = 'limpack_aviso_perfil_dismiss'

/**
 * Banner sticky que avisa al cliente que tiene que completar su perfil
 * (nombre + teléfono) antes de poder comprar/suscribirse.
 *
 * Se muestra en todas las páginas del cliente salvo /cliente/perfil
 * (donde ya está cargando los datos). Es dismissable por sesión.
 */
export default function AvisoPerfilIncompleto() {
  const { profile, loading } = useAuth()
  const location = useLocation()
  const [dismissed, setDismissed] = useState(() => {
    try { return sessionStorage.getItem(SS_KEY) === '1' } catch { return false }
  })

  if (loading) return null
  if (location.pathname === '/cliente/perfil') return null

  const tieneNombre = !!(profile?.nombre && profile.nombre.trim().length > 1)
  const tienePhone = !!(profile?.phone && profile.phone.trim().length >= 8)
  const completo = tieneNombre && tienePhone

  if (completo || dismissed) return null

  const faltan = [
    !tieneNombre && 'nombre',
    !tienePhone && 'teléfono',
  ].filter(Boolean).join(' y ')

  function handleClose() {
    try { sessionStorage.setItem(SS_KEY, '1') } catch {}
    setDismissed(true)
  }

  return (
    <div className="api-banner">
      <div className="api-icon">⚠️</div>
      <div className="api-text">
        <strong>Completá tu perfil</strong> para poder comprar o suscribirte.
        {' '}Te falta cargar tu <strong>{faltan}</strong>.
      </div>
      <Link to="/cliente/perfil" className="api-cta">Completar →</Link>
      <button type="button" onClick={handleClose} className="api-close" aria-label="Cerrar">×</button>

      <style>{`
        .api-banner {
          position: sticky; top: 0; z-index: 35;
          background: linear-gradient(135deg, #fef3c7, #fde68a);
          border-bottom: 1.5px solid #facc15;
          padding: 10px 14px;
          display: flex; align-items: center; gap: 10px;
          font-size: 13px; color: #78350f; line-height: 1.4;
        }
        .api-icon { font-size: 18px; flex-shrink: 0 }
        .api-text { flex: 1 }
        .api-text strong { color: #92400e }
        .api-cta {
          padding: 7px 12px; background: #92400e; color: #fff;
          border-radius: 8px; font-size: 12px; font-weight: 800;
          text-decoration: none; white-space: nowrap; flex-shrink: 0;
        }
        .api-cta:hover { background: #78350f }
        .api-close {
          background: transparent; border: 0; color: #78350f;
          font-size: 22px; line-height: 1; cursor: pointer; padding: 0 4px;
          font-family: inherit; flex-shrink: 0;
        }
        .api-close:hover { color: #422006 }
        @media (max-width: 600px) {
          .api-banner { font-size: 12.5px; padding: 9px 10px; gap: 8px }
          .api-text strong { display: inline }
          .api-cta { padding: 6px 10px; font-size: 11.5px }
        }
        /* En desktop el sidebar ocupa 240px → corremos el banner */
        @media (min-width: 900px) {
          .api-banner { margin-left: 240px }
        }
      `}</style>
    </div>
  )
}
